/**
 * Created by iamso on 30.08.2021
 */

const GrowthFundBuyWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this._super({
            name: "GrowthFundBuyWindow",
            title: Messages.get("GrowthFundBuyWindow.title"),
            content: this.createContent()
        });

        this.createBadge();

        cleverapps.paymentsLogic.onChangeStatus(this.updateButton.bind(this), this);
        cleverapps.growthFund.on("bought", this.close.bind(this), this);
    },

    updateButton: function () {
        if (connector.payments.isConnected()) {
            this.button.enable();
        } else {
            this.button.disable();
        }
    },

    getPerson: function () {
        return cleverapps.persons.choose("seller");
    },

    createContent: function () {
        const styles = cleverapps.styles.GrowthFundBuyWindow;

        this.button = this.createBuyButton();
        const textNode = this.creteTextNode();
        const icon = new cleverapps.Spine(bundles.growth_fund.jsons.buy_fund_safe);
        icon.setAnimationAndIdleAfter("open", "idle");

        return new cleverapps.Layout([icon, textNode, this.button], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    creteTextNode: function () {
        const styles = cleverapps.styles.GrowthFundBuyWindow.text;

        const createLine = function (msg, amount) {
            const cta = cleverapps.UI.generateOnlyText(msg, cleverapps.styles.FONTS.WINDOW_TEXT);
            const amountText = cleverapps.UI.generateImageText(cleverapps.formatAmount(amount), cleverapps.styles.FONTS.GROWTH_FUND_RECEIVE_AMOUNT);
            const icon = new cc.Sprite(bundles.growth_fund.frames.rubies);

            const amountBlock = new cleverapps.Layout([amountText, icon], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.iconMargin
            });

            return new cleverapps.Layout([cta, amountBlock], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.margin
            });
        };

        const line1 = createLine(Messages.get("GrowthFundBuyWindow.text1"), cleverapps.growthFund.getTotalWaitingRewards());
        const line2 = createLine(Messages.get("GrowthFundBuyWindow.text2"), GrowthFund.LEVELS.rewards.default);

        return new cleverapps.Layout([line1, line2], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.lineMargin
        });
    },

    createBuyButton: function () {
        const product = cleverapps.growthFund.getProduct();

        const btn = new cleverapps.UI.Button({
            text: product.getCurrentPrice(),
            onClicked: function () {
                cleverapps.growthFund.buy();
            },
            width: cleverapps.styles.GrowthFundBuyWindow.button.width,
            height: cleverapps.styles.GrowthFundBuyWindow.button.height
        });
        return btn;
    },

    createBadge: function () {
        const styles = cleverapps.styles.GrowthFundBuyWindow.badge;

        const badge = new TileBadge({
            type: "value",
            value: "800%"
        });
        badge.setAlignment(styles);
        this.window.addChild(badge);
    },

    listBundles: function () {
        return ["growth_fund"];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    GROWTH_FUND_RECEIVE_AMOUNT: {
        name: "nostroke",
        size: 53,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    }
});

cleverapps.styles.GrowthFundBuyWindow = {
    margin: 20,

    text: {
        margin: 20,
        iconMargin: 5,
        lineMargin: 0
    },

    badge: {
        x: { align: "right", dx: 40 },
        y: { align: "bottom", dy: -40 }
    },

    button: {
        width: 240,
        height: 95
    }
};
